import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { CopyButton } from '../CopyButton';
import { TextField } from '../TextField';
import styles from './CopyField.module.scss';
export const GetCopyFieldTID = (parentTestId)=>getTestIds(parentTestId);
export const CopyField = (_0)=>{
    let { value, label, size, onCopySuccess, onCopyFailure, className, testId } = _0, biProps = _object_without_properties(_0, [
        "value",
        "label",
        "size",
        "onCopySuccess",
        "onCopyFailure",
        "className",
        "testId"
    ]);
    const { CopyFieldTestIds } = useMemo(()=>GetCopyFieldTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(TextField, {
        // eslint-disable-next-line custom/no-hardcoded-nobi-in-seagull -- read-only holder: the copy click is CopyField's only interaction, and the CopyButton suffix logs it
        noBi: true,
        className: className,
        testId: testId,
        label: label,
        size: size,
        value: value,
        inputProps: {
            readOnly: true
        },
        inputRootClass: styles.copyFieldInputRoot,
        suffix: /*#__PURE__*/ _jsx(CopyButton, _object_spread({
            copyText: value,
            testId: CopyFieldTestIds.CopyButton(),
            onSuccess: onCopySuccess,
            onFailure: onCopyFailure
        }, biProps))
    });
};
